import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/vas_premium"
  }, React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.65932 9.25417C4.44877 9.12932 4.14951 9.04185 3.83183 9.178C3.35672 9.38162 2.34104 9.71533 1.89259 9.85674L1.09265 9.0568C1.74715 7.78013 3.42459 5.14923 4.89841 4.83896C5.71581 4.66687 6.2454 4.81739 6.56947 5.05522C6.94118 4.62384 7.37835 4.15269 7.89198 3.63905C11.8017 -0.270635 14.6797 1.32027 14.6797 1.32027C14.6797 1.32027 16.1188 4.04643 12.2551 8.00235C11.7458 8.51165 11.2782 8.94577 10.8498 9.31545C11.1467 9.61969 11.3743 10.1788 11.1768 11.1173C10.8665 12.5911 8.23559 14.2685 6.95892 14.923L6.15899 14.1231C6.30039 13.6746 6.6341 12.659 6.83772 12.1838C6.9849 11.8404 6.87077 11.5185 6.73058 11.307C6.70434 11.2954 6.69188 11.2869 6.69188 11.2869L4.65932 9.25417ZM4.56335 14.0072C3.85351 14.7171 1 15 1 15C1 15 1.28293 12.1465 1.99277 11.4366C2.70262 10.7268 3.85351 10.7268 4.56335 11.4366C5.2732 12.1465 5.2732 13.2974 4.56335 14.0072ZM9.77079 5.97457C10.3035 6.50729 11.1672 6.50729 11.7 5.97457C12.2327 5.44185 12.2327 4.57813 11.7 4.04541C11.1672 3.51268 10.3035 3.51268 9.77079 4.04541C9.23807 4.57813 9.23807 5.44185 9.77079 5.97457Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { VasPremium16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var VasPremium16 = createIcon(IconComponent);